const pathname = window.location.pathname
const search = window.location.search

export default () => {
  let isSpot = true;
  let isFavoriteSpot = false;
  let isArbitrarySpot = false;
  let id;
  let lat;
  let lon;

  // use for dev
  if (pathname.indexOf('/complete-report') > -1) {
    id = 175343
    // id = 180917
    // id = 168372
    // lat = '41.151'
    // lon = '-123.932'
    // isArbitrarySpot = true
    // isFavoriteSpot = true
    // isSpot = false
  }

  // Routed spot URLs (see WindAlert-Web Global.asax):
  //   /spot/{id}                 station spot
  //   /spot/{lat}/{lon}          arbitrary spot
  //   /favspot/{id}              favorite spot
  //   /favspot/{id}/{lat}/{lon}  favorite spot with coordinates
  const routed = pathname.match(/\/(spot|favspot)\/([^/]+)(?:\/([^/]+))?(?:\/([^/]+))?\/?$/);

  if (routed) {
    const [, spotType, first, second, third] = routed;

    if (spotType === 'spot') {
      if (second !== undefined) {
        lat = first;
        lon = second;
        isArbitrarySpot = true;
        isSpot = false;
      } else {
        id = first;
      }
    } else {
      id = first;
      isFavoriteSpot = true;
      isSpot = false;

      if (second !== undefined && third !== undefined) {
        lat = second;
        lon = third;
      }
    }
  }

  if (search.indexOf('latlon') > -1) {
    const params = new URL(document.location).searchParams
    const coords = params.get('latlon').split(',');

    lat = coords[0];
    lon = coords[1];
    isArbitrarySpot = true;
    isSpot = false;
  }

  return {
    id,
    lat,
    lon,
    isSpot,
    isFavoriteSpot,
    isArbitrarySpot
  }
}